// Sync commit actions. The async orchestration (transcode the photos, drive the AuthClient,
// POST the multipart, commit the result) lives on the SuggestionPanel host — StateMachine
// actions are synchronous.
export default {
  setPhase(sm, payload) { sm.commit("phase", payload); },
  setFocus(sm, payload) { sm.commit("focus", payload); },
  setFiles(sm, payload) { sm.commit("files", payload || []); },
  setBusy(sm, payload) { sm.commit("busy", !!payload); },
  setProgress(sm, payload) { sm.commit("progress", payload || 0); },
  setStatus(sm, payload) { sm.commit("status", payload || null); },

  // Inline auth.
  setPerson(sm, payload) { sm.commit("person", payload || null); },
  setAuthEmail(sm, payload) { sm.commit("authEmail", payload || null); },
  setAuthBusy(sm, payload) { sm.commit("authBusy", !!payload); },
  setAuthStatus(sm, payload) { sm.commit("authStatus", payload || null); },

  // A trigger button was pressed. Opening always returns to the FIRST step — a person who
  // sends one suggestion and immediately opens another wants a fresh contribution form, not
  // the thank-you they already read (nor a stale auth panel).
  openWithFocus(sm, focus) {
    sm.commit("focus", focus);
    sm.commit("open", true);
    sm.commit("phase", "contribution");
    sm.commit("status", null);
    sm.commit("authStatus", null);
  },

  close(sm) {
    sm.commit("open", false);
  },

  // Reset the inline-auth flow back to the identity step (a "Back", a logout, or after a
  // failed round). Clears the auth status but keeps the contribution draft and any prefilled
  // email — the submission is unchanged; only the auth attempt is being restarted.
  resetAuth(sm) {
    sm.commit("phase", "identity");
    sm.commit("authBusy", false);
    sm.commit("authStatus", null);
  },

  // The submission landed. The draft is cleared but the panel stays open on the thank-you,
  // so the person can see that it went.
  sent(sm) {
    sm.commit("phase", "sent");
    sm.commit("files", []);
    sm.commit("busy", false);
    sm.commit("progress", 0);
    sm.commit("authBusy", false);
    sm.commit("authStatus", null);
  },
};
